<template>
  <Dialog
    title="素材配置"
    width="40%"
    top="15vh"
    :visible.sync="status"
    append-to-body
  >
    <Form
      label-position="right"
      label-width="150px"
      :model="formCustData"
      :rules="rules"
      ref="formDataRef"
    >
      <FormItem label="练习名称" prop="title">
        <Input
          v-model="formCustData.title"
          style="width: 75%"
          placeholder="请输入练习名称"
        ></Input>
      </FormItem>
      <FormItem label="自定义内容" prop="readContents">
        <Input
          type="textarea"
          v-model="formCustData.readContents"
          maxlength="1000"
          rows="20"
          style="width: 75%"
          show-word-limit
          placeholder="请输入或粘贴想要布置练习作业的素材：字，段落或文章"
        ></Input>
      </FormItem>
      <FormItem>
        <el-button class="fBtn cancel" round @click="status = false"
          >取消</el-button
        >
        <el-button
          class="fBtn finish"
          round
          type="success"
          :disabld="false"
          @click="submitForm"
          >完成</el-button
        >
      </FormItem>
    </Form>
  </Dialog>
</template>

<script>
import { Dialog, Form, FormItem, Input, Button } from "element-ui";
export default {
  data() {
    return {
      status: false,
      formCustData: {
        title: "",
        readContents: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入练习名称", trigger: "change" },
        ],
        readContents: [
          { required: true, message: "请输入自定义内容", trigger: "change" },
        ],
      },
    };
  },
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    ElButton: Button,
  },
  watch: {
    status(val) {
      if (this.$refs?.formDataRef) this.$refs.formDataRef.clearValidate();
    },
  },
  methods: {
    submitForm() {
      this.$refs.formDataRef.validate(async (valid) => {
        console.log(valid);
        if (valid) {
          this.status = false;
          this.$emit("onCustomData", this.formCustData);
        }
      });
    },

    // 布置作业sure
    resetData() {
      this.formCustData = {};
    },
  },
};
</script>

<style lang="less" scoped>
.fBtn {
  width: 40%;
  height: 50px;
  border-radius: 25px;

  &.cancel {
    width: 28%;
    margin-left: 2%;
  }

  &.finish {
    background-color: #FB7C33;
    border-color: #FB7C33;
  }
}
</style>
